module.exports = __webpack_public_path__ + "img/tech__wall.be629c64.svg";